document.addEventListener('DOMContentLoaded', function () {
  var BADGE_SELECTOR = '[data-cart-count]';

  // --- отрисовка кружочка ---

  function renderCount(count) {
    var n = parseInt(count, 10) || 0;

    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      badge.textContent = n;
      badge.classList.toggle('is-hidden', n <= 0);
    });
  }

  // --- определяем, является ли позиция "скрытым трюфелем из бокса" ---

  function isHiddenTruffleItem(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;

    // наши helper-строки создаются так:
    // properties: { _box_builder: '1', _box_id: '...', truffle_title: 'TRUFFLE 1' }
    return p._box_builder === '1' && typeof p.truffle_title !== 'undefined' && p.truffle_title !== null && p.truffle_title !== '';
  }

  // --- считаем только нужные товары ---

  function getVisibleItemCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    var total = 0;

    cart.items.forEach(function (item) {
      if (isHiddenTruffleItem(item)) {
        // это отдельный трюфель из бокса – пропускаем
        return;
      }

      // всё остальное считаем по quantity
      total += item.quantity || 0;
    });

    return total;
  }

  // --- тянем корзину с сервера и обновляем бейдж ---

  function refreshFromServer() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var visibleCount = getVisibleItemCount(cart);
        renderCount(visibleCount);
      })
      .catch(function () {
        // тихо игнорируем
      });
  }

  // 1) стартуем из того, что уже вёрстка подставила (может быть cart.item_count)
  var firstBadge = document.querySelector(BADGE_SELECTOR);
  if (firstBadge) {
    renderCount(firstBadge.textContent);
  }

  // 2) сразу же синхронизируемся с реальной корзиной
  refreshFromServer();

  // 3) перехват всех fetch к /cart/... — чтобы счётчик менялся БЕЗ перезагрузки

  if (window.fetch) {
    var originalFetch = window.fetch;

    window.fetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url);

      var shouldRefresh = url && (
        url.indexOf('/cart/add')    !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear')  !== -1
      );

      return originalFetch.apply(window, args).then(function (res) {
        if (shouldRefresh) {
          // даём Shopify чуть времени обновить cart
          setTimeout(refreshFromServer, 150);
        }
        return res;
      });
    };
  }
});
